/* RESPONSIBLE TEAM: team-data-foundations */

export const AUDIENCE_FILTER_EVERYONE = 'everyone';
export const AUDIENCE_FILTER_CUSTOM = 'custom';
export const AUDIENCE_FILTER_NA = 'na';
